
// import CustomerInvoiceTemplate from "./CustomerInvoiceAfterEnd";

// export const handleBrowserPrintAfterEnd = async (orderDetails, invoiceData, orderId) => {
//   const printWindow = window.open("", "printWindow", "width=400,height=600");
//   if (!printWindow) {
//     alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
//     return;
//   }

//   const html = await CustomerInvoiceTemplate(orderDetails, invoiceData, orderId);

//   printWindow.document.open();
//   printWindow.document.write(html);
//   printWindow.document.close();
//   printWindow.focus();

//   const tryClose = () => {
//     try {
//       if (printWindow && !printWindow.closed) printWindow.close();
//     } catch (e) {}
//   };

//   printWindow.onafterprint = tryClose;
//   try {
//     printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
//   } catch (e) {}

//   const fallbackTimer = setTimeout(() => tryClose(), 12000);

//   // ✅ انتظر تحميل الصور/الخطوط ثم اطبع
//   const safePrint = async () => {
//     try {
//       // لو السكريبت داخل الـ HTML اتسجل
//       if (printWindow.__waitForAssets) {
//         await printWindow.__waitForAssets();
//       } else {
//         // fallback بسيط
//         await new Promise((r) => setTimeout(r, 400));
//       }
//     } catch (e) {}

//     try {
//       printWindow.print();
//     } catch (e) {
//       console.error("❌ فشل أمر الطباعة", e);
//     }
//   };

//   await safePrint();

//   const pollInterval = setInterval(() => {
//     if (!printWindow || printWindow.closed) {
//       clearInterval(pollInterval);
//       clearTimeout(fallbackTimer);
//     }
//   }, 500);
// };

import CustomerInvoiceTemplate from "./CustomerInvoiceAfterEnd";

// =========================
// helpers
// =========================
const readDiscountFromLS = (orderId) => {
  try {
    const raw = localStorage.getItem(`invoice_discount_${orderId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const discount = Number(parsed.discount || 0);
    const discount_ratio = Number(parsed.discount_ratio || 0);

    return {
      discount,
      discount_ratio,
      // لو ratio > 0 اعتبره Percentage
      discount_is_percentage: discount_ratio > 0 ? 1 : 0,
    };
  } catch (e) {
    console.warn("⚠️ readDiscountFromLS failed:", e);
    return null;
  }
};

// ✅ تطبيع شكل orderDetails لو اتبعت بالغلط كـ { order, items, invoiceSettings }
const normalizeOrderDetails = (orderDetails, orderId) => {
  if (!orderDetails) return {};

  // لو اتبعت كـ { order: {...} }
  if (orderDetails.order) {
    const base = orderDetails.order;

    return {
      ...base,
      // items ممكن تكون في wrapper أو جوه base
      items: orderDetails.items || base.items || [],
      // بعض الباك اند بيرجع customer داخل customer
      customer: base.customer || orderDetails.customer,
      // رقم الاوردر
      general_increment: base.general_increment || base.generalIncrement || base.increment || orderId,
    };
  }

  // لو اتبعت كـ order مباشر
  return {
    ...orderDetails,
    items: orderDetails.items || [],
    general_increment:
      orderDetails.general_increment ||
      orderDetails.generalIncrement ||
      orderDetails.increment ||
      orderId,
  };
};

// ✅ تطبيع invoiceData لضمان إن template يلاقي tax/delivery/discount بشكل صحيح
const normalizeInvoiceData = (invoiceData = {}) => {
  const src = invoiceData || {};

  return {
    // subtotal
    sub_total: Number(src.sub_total || src.subtotal || 0),

    // tax
    tax: Number(src.tax || 0),
    tax_ratio: Number(src.tax_ratio || 0),
    tax_is_percentage: Number(src.tax_is_percentage || 0),

    // delivery
    delivery: Number(src.delivery || 0),
    delivery_ratio: Number(src.delivery_ratio || 0),
    delivery_is_percentage: Number(src.delivery_is_percentage || 0),

    // discount
    discount: Number(src.discount || 0),
    discount_ratio: Number(src.discount_ratio || 0),
    discount_is_percentage: Number(src.discount_is_percentage || 0),

    // header/footer optional
    header_text: src.header_text || "",
    footer_text: src.footer_text || "",

    // print number optional
    order_print_number: Number(src.order_print_number || 1),

    // total optional
    total_amount: Number(src.total_amount || 0),
  };
};

// =========================
// main
// =========================
export const handleBrowserPrintAfterEnd = async (orderDetails, invoiceData, orderId) => {
  // ✅ 0) normalize incoming data to avoid missing customer/items/order number
  const normalizedOrder = normalizeOrderDetails(orderDetails, orderId);

  // ✅ 1) normalize invoiceData then inject discount from localStorage
  const normalizedInvoice = normalizeInvoiceData(invoiceData);

  const lsDiscount = readDiscountFromLS(orderId);
  const invoiceDataForPrint = {
    ...normalizedInvoice,
    ...(lsDiscount
      ? {
          discount: lsDiscount.discount,
          discount_ratio: lsDiscount.discount_ratio,
          discount_is_percentage: lsDiscount.discount_is_percentage,
        }
      : {}),
  };

  // ✅ Debug سريع (شيله بعد التأكد)
  // console.log("🧾 PrintAfterEnd order.customer:", normalizedOrder?.customer);
  // console.log("🧾 PrintAfterEnd order.general_increment:", normalizedOrder?.general_increment);
  // console.log("🧾 PrintAfterEnd items:", (normalizedOrder?.items || []).length);
  // console.log("🧾 PrintAfterEnd invoiceDataForPrint:", invoiceDataForPrint);

  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  // ✅ 2) ابعت normalizedOrder + invoiceDataForPrint
  const html = await CustomerInvoiceTemplate(normalizedOrder, invoiceDataForPrint, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
